import Customer from '@/shared/types/customer.type';
import QuoteResponse from '@/shared/types/order/quotes/quoteResponse.type';
import ProductOrder from '@/shared/types/productOrder.type';

type CartState = {
  productsInCart: ProductOrder[];
  assignedQuote?: QuoteResponse;
  assignedCustomer?: Customer;
};

type CartAction =
  | { type: 'ADD_PRODUCT'; product: ProductOrder }
  | { type: 'UPDATE_PRODUCT'; product: ProductOrder }
  | { type: 'REMOVE_PRODUCT'; id: string }
  | { type: 'CLEAR_CART' }
  | { type: 'ASSIGN_CUSTOMER'; customer: Customer }
  | { type: 'UNASSIGN_CUSTOMER' }
  | { type: 'ASSIGN_QUOTE'; quote: QuoteResponse }
  | { type: 'UNASSIGN_QUOTE' }
  | { type: 'UPDATE_QUOTE'; quote: QuoteResponse };

export const initialState: CartState = {
  productsInCart: [],
};

const cartReducer = (state: CartState, action: CartAction): CartState => {
  switch (action.type) {
    case 'ADD_PRODUCT': {
      const itemInTheCart = state.productsInCart.find(
        (item) => item.id === action.product.id,
      );

      const updatedProducts = itemInTheCart
        ? state.productsInCart.map((item) =>
            item.id === action.product.id
              ? {
                  ...item,
                  product_qty: (parseInt(item.product_qty) + 1).toFixed(0),
                }
              : item,
          )
        : [...state.productsInCart, action.product];

      return { ...state, productsInCart: updatedProducts };
    }
    case 'UPDATE_PRODUCT': {
      const updatedProducts = state.productsInCart.map((item) =>
        item.id === action.product.id ? { ...item, ...action.product } : item,
      );
      return { ...state, productsInCart: updatedProducts };
    }
    case 'REMOVE_PRODUCT': {
      const updatedProducts = state.productsInCart.filter(
        (item) => item.id !== action.id,
      );
      return { ...state, productsInCart: updatedProducts };
    }
    case 'CLEAR_CART': {
      return { ...state, productsInCart: [] };
    }
    case 'ASSIGN_CUSTOMER': {
      return { ...state, assignedCustomer: action.customer };
    }
    case 'UNASSIGN_CUSTOMER': {
      return { ...state, assignedCustomer: undefined };
    }
    case 'ASSIGN_QUOTE': {
      return { ...state, assignedQuote: action.quote };
    }
    case 'UNASSIGN_QUOTE': {
      return { ...state, assignedQuote: undefined };
    }
    case 'UPDATE_QUOTE': {
      return {
        ...state,
        assignedQuote: {
          ...state.assignedQuote,
          ...action.quote,
        },
      };
    }
    default:
      return state;
  }
};

export default cartReducer;
